module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "qcxj-community-box",
    staticStyle: {
      "padding": ".2rem 0 1rem 0"
    }
  }, [_c('van-list', {
    attrs: {
      "finished": _vm.finished,
      "finished-text": "没有更多了"
    },
    on: {
      "load": _vm.onLoad
    },
    model: {
      value: (_vm.loading),
      callback: function($$v) {
        _vm.loading = $$v
      },
      expression: "loading"
    }
  }, _vm._l((_vm.list), function(item, index) {
    return _c('div', [(item.type != 1) ? _c('van-cell', {
      attrs: {
        "is-link": ""
      },
      on: {
        "click": function($event) {
          return _vm.deleteUser(item.user_id, index)
        }
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('img', {
      staticClass: "cell-img",
      attrs: {
        "src": item.face,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "custom-title"
    }, [_vm._v(_vm._s(item.user_name))]), _vm._v(" "), _c('div', {
      staticClass: "van-cell__label"
    }, [_vm._v(_vm._s(item.user_type))])])], 2) : _c('van-cell', [_c('template', {
      slot: "title"
    }, [_c('img', {
      staticClass: "cell-img",
      attrs: {
        "src": item.face,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "custom-title"
    }, [_vm._v(_vm._s(item.user_name))]), _vm._v(" "), _c('div', {
      staticClass: "van-cell__label"
    }, [_vm._v(_vm._s(item.user_type))])])], 2)], 1)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": ""
    },
    on: {
      "click": _vm.toUserCreate
    }
  }, [_vm._v("新增用户\n      ")])], 1), _vm._v(" "), _c('JianduPicker', {
    attrs: {
      "show": _vm.showJianduPicker,
      "limit": 1,
      "defaultValue": _vm.formData.jiandu
    },
    on: {
      "onChange": _vm.onJianduChange,
      "onClose": function($event) {
        _vm.showJianduPicker = false
      },
      "onConfirm": _vm.onJianduConfirm
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-87d7592e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/qcxj/QcxjDetailCommunity.vue
// module id = 2515
// module chunks = 0